import React, { Suspense, lazy } from 'react';

import styled from 'styled-components';
import ErrorBoundary from 'src/error/components/ErrorBoundary';
import { DATA_TEST_ID } from './constants';
import type { MountainsContainerProps } from './components/MountainsContainer/MountainsContainer';

const MountainsContainer = lazy(
  () =>
    import(
      /* webpackChunkName: "MountainsContainer" */ './components/MountainsContainer'
    ),
);

interface SubscribeMobileMountainsProps
  extends Pick<MountainsContainerProps, 'onCloseMountains'> {
  isMountainsActive?: boolean;
  isLoaded: boolean;
  countryName?: string;
}

export const SubscribeMobileMountains = ({
  countryName,
  onCloseMountains,
  children,
  isMountainsActive = false,
  isLoaded,
}: LT.WithChildren<SubscribeMobileMountainsProps>): JSX.Element =>
  isMountainsActive && countryName && isLoaded ? (
    <ErrorBoundary
      showDialog={false}
      fallback={<Container>{children}</Container>}
    >
      <Suspense fallback={<Container>{children}</Container>}>
        <Container data-testid={DATA_TEST_ID}>
          <MountainsContainer
            countryName={countryName}
            onCloseMountains={onCloseMountains}
          >
            {children}
          </MountainsContainer>
        </Container>
      </Suspense>
    </ErrorBoundary>
  ) : (
    <Container>{children}</Container>
  );

const Container = styled.div`
  position: sticky;

  z-index: 1;

  bottom: 0;
  left: 0;
  padding-bottom: 20px;

  width: 100vw;
`;
